/* PENDING CLEAN UP*/
import { apiHelper } from '@/utils/api.helper'

export const COMMON = {
  resetPassword,
  getLanguageList,
  countryList,
  requestOTP,
  verifyOTP,
  verifyEmail,
  verifyReferralCode,
  getStoreList,
  getStoreDetails,
  uploadMedia
}

const URL = {
  COMMON: 'common',
  COUNTRY_LIST: 'country_list',
  LANGUAGE_LIST: 'language_list',
  REQUEST_OTP: 'requestSMSOTP',
  VERIFY_OTP: 'verify_otp',
  VERIFY_EMAIL: 'verify_unique_email',
  VERIFY_REFERRAL_CODE: 'validate_referral_code',
  STORE_LIST: 'storelist',
  STORE_DETAILS: 'storedetails',
  UPLOAD_MEDIA: 'upload',
  RESET_PASSWORD: 'resetpassword'
}

function countryList() {
  return apiHelper(false).get(`${URL.COMMON}/${URL.COUNTRY_LIST}`)
}

function getLanguageList() {
  return apiHelper().get(`${URL.COMMON}/${URL.LANGUAGE_LIST}`)
}

function requestOTP(form) {
  let requestBody = {
    country_id: form.mobileNumber.country_id,
    mobile: form.mobileNumber.mobile,
    type: form.type
  }

  return apiHelper(false).post(`${URL.COMMON}/${URL.REQUEST_OTP}`, null, {
    params: requestBody
  })
}

function verifyOTP(form) {
  let requestBody = {
    country_id: form.mobileNumber.country_id,
    mobile: form.mobileNumber.mobile,
    otp: form.otp,
    type: form.type
  }

  return apiHelper(false).post(`${URL.COMMON}/${URL.VERIFY_OTP}`, null, {
    params: requestBody
  })
}

function verifyEmail(form) {
  let requestBody = {
    email: form.email
  }

  return apiHelper(false).post(`${URL.COMMON}/${URL.VERIFY_EMAIL}`, null, {
    params: requestBody
  })
}

function verifyReferralCode(form) {
  let requestBody = {
    referral_code: form.referralCode
  }

  return apiHelper(false).post(`${URL.COMMON}/${URL.VERIFY_REFERRAL_CODE}`, null, {
    params: requestBody
  })
}

function resetPassword(form) {
  let requestBody = {
    otp: form.otp,
    country_id: form.mobileNumber.country_id,
    mobile: form.mobileNumber.mobile,
    password: form.newPassword,
    password_confirmation: form.confirmPassword
  }
  return apiHelper(false).put(`${URL.COMMON}/${URL.RESET_PASSWORD}`, null, {
    params: requestBody
  })
}

function getStoreList(data) {
  return apiHelper().get(`${URL.COMMON}/${URL.STORE_LIST}`, { params: data })
}

function getStoreDetails(data) {
  let requestBody = {
    store_id: data.storeId
  }
  return apiHelper().post(`${URL.COMMON}/${URL.STORE_DETAILS}`, null, {
    params: requestBody
  })
}

function uploadMedia(data) {
  const requestHeader = {
    'Content-Type': 'multipart/form-data'
  }
  let requestParams = {
    name: data.name
  }
  return apiHelper(true, requestHeader).post(`${URL.COMMON}/${URL.UPLOAD_MEDIA}`, data.formData, {
    params: requestParams
  })
}
